if (!customElements.get('vv-mobile-search')) {
  customElements.define('vv-mobile-search', class extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.header-wrapper');
      this.toggle = this.wrapper.querySelector('.vv-mobile-search-toggle');
      this.input = this.querySelector('input[type="search"]');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.toggle.addEventListener('click', () => this.open(), options);
      this.querySelector('.vv-mobile-search-close').addEventListener('click', () => this.close(), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
        }
      }, options);
      window.matchMedia('(max-width: 749px)').addEventListener('change', () => this.close(false), options);
      this.wrapper.classList.add('vv-mobile-search-ready');
    }

    disconnectedCallback() {
      this.events.abort();
      this.wrapper.classList.remove('vv-mobile-search-ready', 'vv-mobile-search-open');
    }

    open() {
      this.wrapper.classList.add('vv-mobile-search-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.input.focus({ preventScroll: true });
    }

    close(restoreFocus = true) {
      const wasOpen = this.wrapper.classList.contains('vv-mobile-search-open');
      this.querySelector('predictive-search')?.close();
      this.wrapper.classList.remove('vv-mobile-search-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      if (wasOpen && restoreFocus) this.toggle.focus({ preventScroll: true });
    }
  });
}
